(function () {
  "use strict";

  if (!document.getElementById("eneto-low-stock-pulse-style")) {
    const style = document.createElement("style");
    style.id = "eneto-low-stock-pulse-style";
    style.textContent = `
      @keyframes eneto-pulse-dot {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.25; }
      }
      .eneto-low-stock-dot {
        display: inline-block;
        animation: eneto-pulse-dot 1.3s ease-in-out infinite;
      }
    `;
    document.head.appendChild(style);
  }

  function initEnetoProductPage() {
    const productSection = document.querySelector(".eneto-step2-grid");
    if (!productSection || productSection.dataset.initialized === "true") return;
    productSection.dataset.initialized = "true";

    if (!window.enetoProductData || !Array.isArray(window.enetoProductData.variants)) return;

    const {
      variants,
      currency,
      selectedVariant,
      mediaImages,
      options,
      variantPopup,
      deliveryTime
    } = window.enetoProductData;

    const curr = currency || "EUR";
    const money = (cents) =>
      new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: curr
      }).format((cents || 0) / 100);

    function formatDiff(diffCents) {
      const euros = Math.round(diffCents / 100);
      if (euros === 0) return "";
      if (euros > 0) {
        return `<span class="eneto-variant-price-diff--positive">+${euros}€</span>`;
      } else {
        return `<span class="eneto-variant-price-diff--negative">–${Math.abs(euros)}€</span>`;
      }
    }

    function calculatePriceDiff(baseVariantId, testVariantId) {
      const base = variants.find((v) => v.id == baseVariantId);
      const test = variants.find((v) => v.id == testVariantId);
      if (!base || !test) return 0;
      return test.price - base.price;
    }

    function updateOptionPriceDiffs(optionIndex, selectedOptions, baseVariantId) {
      if (typeof optionIndex !== "number") return;
      if (!baseVariantId) return;

      const buttons = document.querySelectorAll(
        `.eneto-variants__group[data-option-index="${optionIndex}"] .eneto-variant-btn`
      );
      if (!buttons.length) return;

      buttons.forEach((btn) => {
        const diffSpan = btn.querySelector(".eneto-variant-price-diff");
        if (!diffSpan) return;

        const newValue = btn.dataset.optionValue;
        const tempOptions = [...selectedOptions];
        tempOptions[optionIndex] = newValue;

        const candidate = variants.find((v) => {
          const opts =
            Array.isArray(v.options) && v.options.length > 0 && v.options[0] != null
              ? v.options
              : [v.option1, v.option2, v.option3].filter(Boolean);

          return (
            opts.length === tempOptions.length &&
            opts.every((opt, i) => opt === tempOptions[i])
          );
        });

        if (!candidate) {
          diffSpan.textContent = "";
          return;
        }

        const diff = calculatePriceDiff(baseVariantId, candidate.id);
        diffSpan.innerHTML = formatDiff(diff);
      });
    }

    const mainImg = document.getElementById("eneto-step1-mainimg");
    const thumbsRoot = document.getElementById("eneto-thumbs");
    const prevBtn = document.getElementById("eneto-gallery-prev");
    const nextBtn = document.getElementById("eneto-gallery-next");
    const zoomContainer = document.getElementById("eneto-zoom-container");
    const lightbox = document.getElementById("eneto-lightbox");
    const lightboxImg = document.getElementById("eneto-lightbox-img");
    const lightboxClose = document.getElementById("eneto-lightbox-close");
    const lightboxPrev = document.getElementById("eneto-lightbox-prev");
    const lightboxNext = document.getElementById("eneto-lightbox-next");
    const images = Array.isArray(mediaImages) ? mediaImages : [];

    // ── ÄNDERUNG 1: Halterungs-Galerie-Logik ──────────────────────
    // Pro Variante: Array mit ALLEN zugehörigen Alt-Text-Markern
    const HALTERUNG_GALLERY_MAP = {
      'Garten':         ['halterung-galerie:garten-flachdach', 'halterung_garten', '2000W-Halterung-Garten-Flachdach', '1000W-Halterung-Garten-Flachdach'],
      'Flachdach':      ['halterung-galerie:garten-flachdach', 'halterung_flachdach', '2000W-Halterung-Garten-Flachdach', '1000W-Halterung-Garten-Flachdach'],
      'Balkon':         ['halterung-galerie:balkon',           'halterung_balkon', '1000W-Halterung-Balkon', '2000W-Halterung-Balkon'],
      'Schrägdach':     ['halterung-galerie:schraegdach',      'halterung_schraegdach', '1000W-Halterung-Schreagedach-Ziegeldach', '2000W-Halterung-Schreagedach-Ziegeldach',],
      'Fassade':        ['halterung-galerie:fassade',          'halterung_fassade', '1000und2000W-Halterung-Fassade'],
      'ohne Halterung': [],
    };
    // Alle bekannten Halterungs-Marker (für Erkennung)
    const ALL_HALTERUNG_MARKERS = [
        'halterung-galerie:',
        'halterung_',
        'halterung-balkon',
        'halterung-garten',
        'halterung-fassade',
        'halterung-schraeg',
        '1000w-halterung',
        '2000w-halterung',
        '1000und2000w-halterung',
    ];

    function isHalterungGalleryImg(img) {
      if (!img?.alt) return false;
      const alt = img.alt.toLowerCase();
      return ALL_HALTERUNG_MARKERS.some(m => alt.includes(m));
    }

    function updateHalterungThumb(halterungValue) {
      if (!thumbsRoot) return;
      const targetMarkers = HALTERUNG_GALLERY_MAP[halterungValue] || [];
      thumbsRoot.querySelectorAll('.eneto-thumb-btn').forEach(btn => {
        const idx = parseInt(btn.dataset.index, 10);
        if (!isHalterungGalleryImg(images[idx])) return;
        const alt = (images[idx]?.alt || '').toLowerCase();
        const matches = targetMarkers.some(m => alt.includes(m.toLowerCase()));
        btn.style.display = matches ? '' : 'none';
        btn.hidden = !matches;
      });
    }
    // ──────────────────────────────────────────────────────────────

    let currentIndex = 0;

    function renderThumbs() {
      if (!thumbsRoot) return;
      thumbsRoot.innerHTML = "";
      images.forEach((img, i) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "eneto-thumb-btn";
        btn.dataset.index = String(i);
        btn.innerHTML = `<img src="${img.thumb}" alt="${img.alt || ""}">`;
        btn.addEventListener("click", () => { showImage(i); });
        thumbsRoot.appendChild(btn);
      });
      const multi = images.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;

      // ── ÄNDERUNG 2: Initial Halterungs-Thumb setzen ──
      const initHIdx = options?.findIndex(o => o.name?.toLowerCase().includes('halterung')) ?? -1;
      if (initHIdx > -1 && selectedOptions[initHIdx]) {
        requestAnimationFrame(() => updateHalterungThumb(selectedOptions[initHIdx]));
      }
      // ─────────────────────────────────────────────────
    }

    function updateThumbActive(index) {
      if (!thumbsRoot) return;
      thumbsRoot.querySelectorAll(".eneto-thumb-btn").forEach((b) => b.classList.remove("is-active"));
      const active = thumbsRoot.querySelector(`.eneto-thumb-btn[data-index="${index}"]`);
      if (active) active.classList.add("is-active");
    }

    function showImage(index) {
      if (!images.length || !mainImg) return;
      currentIndex = (index + images.length) % images.length;
      const img = images[currentIndex];
      mainImg.src = img.src;
      mainImg.alt = img.alt || "";
      mainImg.removeAttribute("srcset");
      updateThumbActive(currentIndex);
    }

    function showImageById(mediaId) {
      const index = images.findIndex((img) => img.id === mediaId);
      if (index > -1) showImage(index);
    }

    function nextImage() { showImage(currentIndex + 1); }
    function prevImage() { showImage(currentIndex - 1); }

    function openLightbox() {
      if (!lightbox || !lightboxImg) return;
      lightboxImg.src = images[currentIndex]?.src || mainImg?.src || "";
      lightbox.hidden = false;
      document.documentElement.classList.add("eneto-no-scroll");
    }

    function closeLightbox() {
      if (lightbox) {
        lightbox.hidden = true;
        document.documentElement.classList.remove("eneto-no-scroll");
        if (lightboxImg) lightboxImg.src = "";
      }
    }

    function lightboxNextImage() {
      nextImage();
      if (!lightbox?.hidden && images[currentIndex]) lightboxImg.src = images[currentIndex].src;
    }

    function lightboxPrevImage() {
      prevImage();
      if (!lightbox?.hidden && images[currentIndex]) lightboxImg.src = images[currentIndex].src;
    }

    function enableHoverZoom() {
      if (!zoomContainer || !mainImg) return;
      let zooming = false;
      zoomContainer.addEventListener("mouseenter", () => {
        if (window.matchMedia("(hover: hover)").matches) { zooming = true; zoomContainer.classList.add("zooming"); }
      });
      zoomContainer.addEventListener("mouseleave", () => {
        zooming = false; zoomContainer.classList.remove("zooming"); mainImg.style.transformOrigin = "";
      });
      zoomContainer.addEventListener("mousemove", (e) => {
        if (!zooming) return;
        const rect = zoomContainer.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = `${x}% ${y}%`;
      });
      zoomContainer.addEventListener("click", openLightbox);
    }

    function initGallery() {
      if (mainImg) {
        renderThumbs();
        if (images.length) {
          const initialVariant = findVariant();
          if (initialVariant?.featured_image?.id) {
            showImageById(initialVariant.featured_image.id);
          } else {
            showImage(0);
          }
        }
        if (prevBtn) prevBtn.addEventListener("click", prevImage);
        if (nextBtn) nextBtn.addEventListener("click", nextImage);
        document.addEventListener("keydown", (e) => {
          if (lightbox && !lightbox.hidden) {
            if (e.key === "ArrowRight") lightboxNextImage();
            if (e.key === "ArrowLeft") lightboxPrevImage();
            if (e.key === "Escape") closeLightbox();
          }
        });
        if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
        if (lightboxPrev) lightboxPrev.addEventListener("click", lightboxPrevImage);
        if (lightboxNext) lightboxNext.addEventListener("click", lightboxNextImage);
        if (lightbox) {
          lightbox.addEventListener("click", (e) => { if (e.target === lightbox) closeLightbox(); });
        }
        enableHoverZoom();
      }
    }

    const priceCurrentEl = document.getElementById("eneto-price-current");
    const priceCompareEl = document.getElementById("eneto-price-compare");

    function updateTotalPrice() {
      let mainPrice = parseInt(document.querySelector("#SelectedVariantId").dataset.price || "0", 10);
      let mainComparePrice = parseInt(document.querySelector("#SelectedVariantId").dataset.comparePrice || "0", 10);
      document.querySelectorAll("[data-addon-group]").forEach((group) => {
        const selectedBtn = group.querySelector('.eneto-variant-btn[aria-pressed="true"]');
        if (selectedBtn) {
          const addonPrice = parseInt(selectedBtn.dataset.price || "0", 10);
          const addonComparePrice = parseInt(selectedBtn.dataset.comparePrice || addonPrice, 10);
          mainPrice += addonPrice;
          mainComparePrice += addonComparePrice > addonPrice ? addonComparePrice : addonPrice;
        }
      });
      if (priceCurrentEl) {
        priceCurrentEl.textContent = money(mainPrice);
        priceCurrentEl.classList.toggle("eneto-price__current--discounted", mainComparePrice > mainPrice);
      }
      if (priceCompareEl) {
        if (mainComparePrice > mainPrice) {
          priceCompareEl.textContent = money(mainComparePrice);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.textContent = "";
          priceCompareEl.hidden = true;
        }
      }
    }

    const root = document.getElementById("eneto-variants-root");
    const idInput = document.getElementById("SelectedVariantId");

    const normalizeOptions = (v) =>
      v
        ? Array.isArray(v.options) && v.options.length > 0 && v.options[0] != null
          ? v.options
          : [v.option1, v.option2, v.option3].filter(Boolean)
        : [];

    let selectedOptions = normalizeOptions(selectedVariant);

    const findVariant = () =>
      variants.find((v) => {
        const opts = normalizeOptions(v);
        return opts.length === selectedOptions.length && opts.every((opt, i) => opt === selectedOptions[i]);
      });

    function renderByVariant(variant) {
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      idInput.dataset.price = variant.price;
      idInput.dataset.comparePrice = variant.compare_at_price || variant.price;
      const deliveryEl = document.getElementById("eneto-delivery-container");
      const atcBtn = document.getElementById("eneto-add-to-cart");
      updateTotalPrice();
      if (deliveryEl && atcBtn) {
        if (variant.available) {
          const deliveryTimeHTML = deliveryTime ? `<span class="delivery-time">${deliveryTime}</span>` : "";
          deliveryEl.innerHTML = `<div style="color: #F97316;"><span class="eneto-low-stock-dot">●</span> Schnell vergriffen${deliveryTimeHTML}</div>`;
          atcBtn.disabled = false;
          atcBtn.textContent = "In den Warenkorb";
        } else {
          deliveryEl.innerHTML = '<div><span style="color: var(--eneto-out-of-stock);">●</span> Ausverkauft</div>';
          atcBtn.disabled = true;
          atcBtn.textContent = "Nicht verfügbar";
        }
      }
      if (variant.featured_image && variant.featured_image.id) showImageById(variant.featured_image.id);

      // ── ÄNDERUNG 3: Halterungs-Thumb bei Variantenwechsel aktualisieren ──
      const hIdx = options?.findIndex(o => o.name?.toLowerCase().includes('halterung')) ?? -1;
      if (hIdx > -1 && selectedOptions[hIdx]) updateHalterungThumb(selectedOptions[hIdx]);
      // ─────────────────────────────────────────────────────────────────────
    }

    function updateUI() {
      const currentVariant = findVariant();
      if (currentVariant) {
        renderByVariant(currentVariant);
        const url = new URL(window.location.href);
        url.searchParams.set("variant", currentVariant.id);
        window.history.replaceState({}, "", url);

        const visualImg = document.getElementById("halterung-visual-img");
        if (visualImg && currentVariant.metafields && currentVariant.metafields.varianten_bild_url) {
          visualImg.src = currentVariant.metafields.varianten_bild_url;
        } else if (visualImg) { visualImg.src = ""; }

        const speicherVisualImg = document.getElementById("speicher-visual-img");
        if (speicherVisualImg && currentVariant.speicher_bild_url) {
          speicherVisualImg.src = currentVariant.speicher_bild_url;
        } else if (speicherVisualImg) { speicherVisualImg.src = ""; }

        const kabelVisualImg = document.getElementById("anschlusskabel-visual-img");
        if (kabelVisualImg && currentVariant.anschlusskabel_bild_url) {
          kabelVisualImg.src = currentVariant.anschlusskabel_bild_url;
        } else if (kabelVisualImg) { kabelVisualImg.src = ""; }
      }

      if (root) {
        root.querySelectorAll(".eneto-variants__group").forEach((group) => {
          const optionIndex = parseInt(group.dataset.optionIndex, 10);
          const display = group.querySelector(".selected-option-display");
          if (display) display.textContent = selectedOptions[optionIndex] ?? "";
          group.querySelectorAll(".eneto-variant-btn").forEach((btn, btnIndex) => {
            const value = btn.dataset.optionValue;
            btn.setAttribute("aria-pressed", String(value === selectedOptions[optionIndex]));
            const tempOptions = [...selectedOptions];
            tempOptions[optionIndex] = value;
            const isAvailable = variants.some((v) => {
              const vOpts = normalizeOptions(v);
              return (
                vOpts.length === tempOptions.length &&
                v.available &&
                vOpts.every((opt, idx) => opt === tempOptions[idx])
              );
            });
            btn.disabled = !isAvailable;

            // "(Basis)" Label für ersten Speicher-Button (optionIndex 1)
            if (optionIndex === 1) {
              const labelSpan = btn.querySelector(".eneto-variant-label");
              if (labelSpan) {
                if (btnIndex === 0) {
                  const baseText = labelSpan.textContent.replace(" (Basis)", "").trim();
                  labelSpan.textContent = baseText + " (Basis)";
                }
              }
            }
          });
        });
      }

      if (root) {
        const currentVariant2 = findVariant();
        const baseId = currentVariant2 ? currentVariant2.id : idInput?.value;
        if (baseId) {
          root.querySelectorAll(".eneto-variants__group").forEach((group) => {
            const idx = parseInt(group.dataset.optionIndex, 10);
            updateOptionPriceDiffs(idx, selectedOptions, baseId);
          });
        }
      }
    }

    function setupVariants() {
      if (!root) { renderByVariant(findVariant()); return; }

      root.addEventListener("click", (e) => {
        const btn = e.target.closest(".eneto-variant-btn");
        if (!btn || btn.disabled) return;
        const group = btn.closest(".eneto-variants__group");
        const optionIndex = parseInt(group.dataset.optionIndex, 10);
        selectedOptions[optionIndex] = btn.dataset.optionValue;

        if (!findVariant()) {
          const possibleVariants = variants.filter((v) => {
            const vOpts = normalizeOptions(v);
            return v.available && vOpts[optionIndex] === selectedOptions[optionIndex];
          });
          if (possibleVariants.length > 0) selectedOptions = normalizeOptions(possibleVariants[0]);
        }
        updateUI();

        // ── Downloads-Tab synchronisieren ────────────────────────
        if (optionIndex === 0) {
          const LOCATION_MAP = {
            'balkon':      'balkon',
            'fassade':     'fassade',
            'garten':      'garten',
            'flachdach':   'garten',
            'schrägdach':  'schraegdach',
            'schraegdach': 'schraegdach',
          };
          const key = (btn.dataset.optionValue || '').toLowerCase().trim();
          let location = 'all';
          for (const [needle, loc] of Object.entries(LOCATION_MAP)) {
            if (key.includes(needle)) { location = loc; break; }
          }
          document.dispatchEvent(new CustomEvent('wattano:location-change', { detail: { location } }));
        }
        // ────────────────────────────────────────────────────────
      });

      const vpOverlay = document.getElementById("eneto-variant-popup");
      const vpClose = document.getElementById("eneto-vp-close");
      const vpTitle = document.getElementById("eneto-vp-title");
      const vpBody = document.getElementById("eneto-vp-body");
      const popupOptionIndex = 0;

      if (popupOptionIndex > -1) {
        const popupBtn = document.querySelector(`[data-popup-trigger-for-option="${popupOptionIndex}"]`);
        if (popupBtn) { popupBtn.hidden = false; popupBtn.addEventListener("click", openVariantPopup); }
      }

      const optionValuesOrdered = popupOptionIndex >= 0 ? options[popupOptionIndex].values || [] : [];

      function findRepresentativeVariantForValue(value) {
        return variants.find((v) => normalizeOptions(v)[popupOptionIndex] === value) || null;
      }

      function buildVariantPopupContent() {
        if (!vpBody) return;
        vpBody.innerHTML = "";
        if (vpTitle) vpTitle.textContent = variantPopup?.title || "Beratung";
        if (popupOptionIndex < 0) {
          vpBody.innerHTML = "<p>Konfigurierte Varianten-Option nicht gefunden.</p>";
          return;
        }
        const seen = new Set();
        optionValuesOrdered.forEach((value) => {
          const match = findRepresentativeVariantForValue(value);
          if (seen.has(value) || !match || !match.metafields || !match.metafields.pop_up_content) return;
          seen.add(value);
          const meta = match.metafields;
          const textHTML = meta.pop_up_content;
          const imgUrl = meta.pop_up_bild_url || null;
          const wrap = document.createElement("section");
          wrap.className = "eneto-vp-item";
          const h = document.createElement("h3");
          h.className = "eneto-vp-variant";
          h.textContent = value;
          const p = document.createElement("div");
          p.className = "eneto-vp-text";
          if (textHTML && !String(textHTML).includes("<")) {
            p.innerHTML = String(textHTML).replace(/\n/g, "<br>");
          } else {
            p.innerHTML = String(textHTML || "");
          }
          wrap.appendChild(h);
          wrap.appendChild(p);
          if (imgUrl) {
            const im = document.createElement("img");
            im.className = "eneto-vp-img";
            im.src = imgUrl;
            im.alt = value;
            wrap.appendChild(im);
          }
          vpBody.appendChild(wrap);
        });
        if (!vpBody.childElementCount) {
          vpBody.innerHTML = "<p>Für die aktuelle Auswahl sind keine passenden Informationen hinterlegt.</p>";
        }
      }

      function openVariantPopup() {
        if (vpOverlay) { buildVariantPopupContent(); vpOverlay.hidden = false; document.documentElement.classList.add("eneto-no-scroll"); }
      }
      function closeVariantPopup() {
        if (vpOverlay) { vpOverlay.hidden = true; document.documentElement.classList.remove("eneto-no-scroll"); }
      }

      if (vpClose) vpClose.addEventListener("click", closeVariantPopup);
      if (vpOverlay) {
        vpOverlay.addEventListener("click", (e) => { if (e.target === vpOverlay) closeVariantPopup(); });
      }
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && vpOverlay && !vpOverlay.hidden) closeVariantPopup();
      });

      updateUI();
    }

    function setupAddonSelector(groupName) {
      const addonGroup = document.querySelector(`[data-addon-group="${groupName}"]`);
      if (!addonGroup) return;
      const visualImg = document.getElementById(`${groupName}-visual-img`);
      const titleDisplay = addonGroup.closest(".eneto-variants__group").querySelector(".selected-option-display");
      const buttons = addonGroup.querySelectorAll(".eneto-variant-btn");
      const popupTrigger = document.getElementById(`${groupName}-popup-trigger`);
      const popupModal = document.getElementById(`${groupName}-popup`);
      const popupClose = popupModal ? popupModal.querySelector(".popup-close") : null;

      addonGroup.addEventListener("click", (event) => {
        const clickedButton = event.target.closest(".eneto-variant-btn");
        if (!clickedButton || clickedButton.getAttribute("disabled") === "true") return;
        buttons.forEach((btn) => btn.setAttribute("aria-pressed", "false"));
        clickedButton.setAttribute("aria-pressed", "true");
        if (visualImg && clickedButton.dataset.visualUrl) {
          visualImg.src = clickedButton.dataset.visualUrl;
        } else if (visualImg) { visualImg.src = ""; }
        if (titleDisplay) titleDisplay.textContent = clickedButton.dataset.title;
        updateTotalPrice();
      });

      if (popupTrigger && popupModal && popupClose) {
        const open = () => { popupModal.hidden = false; document.documentElement.classList.add("eneto-no-scroll"); };
        const close = () => { popupModal.hidden = true; document.documentElement.classList.remove("eneto-no-scroll"); };
        popupTrigger.addEventListener("click", open);
        popupClose.addEventListener("click", close);
        popupModal.addEventListener("click", (e) => { if (e.target === popupModal) close(); });
        document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !popupModal.hidden) close(); });
      }
    }

    function setupShippingPopup() {
      const trigger = document.getElementById("shipping-cost-trigger");
      const popup = document.getElementById("shipping-cost-popup");
      if (!trigger || !popup) return;
      const closeBtn = popup.querySelector(".popup-close");
      const postcodeIn = document.getElementById("shipping-postcode-input");
      const ui = {
        subtotal: document.getElementById("shipping-subtotal"),
        shippingCost: document.getElementById("shipping-cost-value"),
        total: document.getElementById("shipping-total"),
        deliveryWindow: document.getElementById("shipping-delivery-window"),
        deliveryContainer: document.getElementById("shipping-delivery-container")
      };
      const popupAtcBtn = document.getElementById("popup-add-to-cart-btn");
      const mainForm = document.getElementById("eneto-atc-form");
      const money2 = (cents) =>
        new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format((cents || 0) / 100);

      function computeDeliveryWindow() {
        const now = new Date();
        const cutoff = new Date(now);
        cutoff.setHours(14, 0, 0, 0);
        const isWeekend = (d) => [0, 6].includes(d.getDay());
        const addBusinessDays = (date, days) => {
          const d = new Date(date);
          let added = 0;
          while (added < days) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) added++; }
          return d;
        };
        const handlingOffset = now <= cutoff && !isWeekend(now) ? 0 : 1;
        const start = addBusinessDays(now, handlingOffset + 1);
        const end = addBusinessDays(now, handlingOffset + 3);
        const fmt = new Intl.DateTimeFormat("de-DE", { weekday: "short", day: "numeric", month: "short" });
        return `${fmt.format(start)} – ${fmt.format(end)}`;
      }

      function renderView(calculateShipping = false) {
        const idInput2 = document.getElementById("SelectedVariantId");
        let subtotalCents = parseInt(idInput2?.dataset.price || "0", 10);
        document.querySelectorAll("[data-addon-group]").forEach((group) => {
          const selectedBtn = group.querySelector('.eneto-variant-btn[aria-pressed="true"]');
          if (selectedBtn) subtotalCents += parseInt(selectedBtn.dataset.price || "0", 10);
        });
        ui.subtotal.textContent = money2(subtotalCents);
        if (calculateShipping) {
          const postcode = postcodeIn.value.trim();
          let shippingCents = 3900;
          const highCostPrefixes = [
            "18565","25849","25859","25863","25869","25938","25946","25980",
            "25992","25996","25997","25999","26465","26474","26486","26548",
            "26571","26579","26757","27498"
          ];
          if (postcode.length === 5 && highCostPrefixes.includes(postcode)) shippingCents = 5900;
          ui.shippingCost.textContent = money2(shippingCents);
          ui.total.textContent = money2(subtotalCents + shippingCents);
          ui.deliveryWindow.textContent = computeDeliveryWindow();
          ui.deliveryContainer.style.display = "block";
        } else {
          ui.shippingCost.textContent = "--,-- €";
          ui.total.textContent = "--,-- €";
          ui.deliveryContainer.style.display = "none";
          ui.deliveryWindow.textContent = "--";
        }
      }

      const open = () => { popup.hidden = false; document.documentElement.classList.add("eneto-no-scroll"); postcodeIn.value = ""; renderView(false); };
      const close = () => { popup.hidden = true; document.documentElement.classList.remove("eneto-no-scroll"); };
      postcodeIn.addEventListener("input", () => { (/^\d{5}$/).test(postcodeIn.value) ? renderView(true) : renderView(false); });
      trigger.addEventListener("click", open);
      closeBtn.addEventListener("click", close);
      popup.addEventListener("click", (e) => { if (e.target === popup) close(); });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !popup.hidden) close(); });
      popupAtcBtn.addEventListener("click", () => { if (mainForm) mainForm.querySelector("#eneto-add-to-cart").click(); close(); });
    }

    function setupCart() {
      const form = document.getElementById("eneto-atc-form");
      if (!form) { console.error("Eneto ATC Form not found."); return; }
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const atcBtn = form.querySelector("#eneto-add-to-cart");
        const originalBtnText = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.setAttribute("aria-busy", "true");
        atcBtn.textContent = "Wird hinzugefügt...";
        try {
          const items = [{ id: document.getElementById("SelectedVariantId").value, quantity: 1 }];
          document.querySelectorAll("[data-addon-group]").forEach((group) => {
            const selectedBtn = group.querySelector('.eneto-variant-btn[aria-pressed="true"]');
            const variantId = selectedBtn ? selectedBtn.dataset.variantId : null;
            if (variantId && variantId !== "none") items.push({ id: variantId, quantity: 1 });
          });
          const formData = new FormData();
          const cartDrawerElement = document.querySelector("cart-drawer");
          const sectionId = cartDrawerElement ? cartDrawerElement.id : "cart-drawer";
          formData.append("sections", sectionId);
          formData.append("sections_url", window.location.pathname);
          items.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
          });
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            body: formData,
            headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" }
          });
          if (!response.ok) throw new Error(await response.text());
          const cartData = await response.json();
          const drawerHtml = cartData.sections[sectionId];
          if (cartDrawerElement && drawerHtml) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = drawerHtml;
            const newDrawerContent = tempDiv.querySelector("cart-drawer");
            if (newDrawerContent) cartDrawerElement.innerHTML = newDrawerContent.innerHTML;
          }
          const totalQuantity = cartData.items.reduce((sum, item) => sum + item.quantity, 0);
          document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((bubble) => {
            if (bubble) { bubble.textContent = totalQuantity; bubble.hidden = totalQuantity === 0; }
          });
          if (cartDrawerElement) {
            typeof cartDrawerElement.show == "function"
              ? cartDrawerElement.show()
              : cartDrawerElement.classList.add("drawer--open");
          }
        } catch (error) {
          console.error("Fehler beim Hinzufügen zum Warenkorb:", error);
          atcBtn.textContent = "Fehler!";
          setTimeout(() => { atcBtn.textContent = originalBtnText; }, 2500);
        } finally {
          atcBtn.disabled = false;
          atcBtn.removeAttribute("aria-busy");
          if (atcBtn.textContent !== "Fehler!") atcBtn.textContent = originalBtnText;
        }
      });
    }

    initGallery();
    setupVariants();
    setupAddonSelector("addon1");
    setupAddonSelector("addon2");
    setupShippingPopup();
    setupCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEnetoProductPage);
  } else {
    initEnetoProductPage();
  }
  document.addEventListener("shopify:section:load", initEnetoProductPage);
})();


// ============================================================
//  INFOBOX-LOGIK
// ============================================================
(function () {

  // ── HALTERUNGS-INFOBOX ──────────────────────────────────────────
  var halterungData = {
    'Balkon':     '⏱ 20–40 Minuten · 🔧 Kein Elektriker · 🏢 Auch für Mietwohnungen geeignet',
    'Flachdach':  '⏱ 30–60 Minuten · 🧱 Keine Dacharbeiten · 📐 Optimaler Winkel',
    'Garten':     '⏱ 20–40 Minuten · 🌞 Frei positionierbar · 🔋 Hoher Eigenverbrauch',
    'Fassade':    '⏱ 1–2 Stunden · 🔩 Stabile Wandmontage · 📏 Platzsparend',
    'Schrägdach': '⏱ 1–2 Stunden · 🏠 Dauerhafte Lösung · 🌬 Sturmfest'
  };
  var halterungColor = 'green';

  function speicherBox(badge, pct, headline, bullets, upsell, upsellStyle) {
    return '<div class="eneto-speicher-content">'
      + '<span class="eneto-speicher-badge">' + badge + '</span>'
      + '<div class="eneto-progress-bar-wrap"><div class="eneto-progress-bar-fill" style="width:' + pct + '%"></div>'
      + '<span class="eneto-progress-bar-label">' + pct + '%</span></div>'
      + '<h3 style="font-size:14px;font-weight:700;color:#000;margin:6px 0 10px 0;">' + headline + '</h3>'
      + '<div class="eneto-speicher-bullets"><div class="eneto-bullet-grid">'
      + bullets.map(function(b){ return '<div class="eneto-bullet-item">' + b + '</div>'; }).join('')
      + '</div></div>'
      + '<div class="eneto-speicher-upsell"' + (upsellStyle ? ' style="' + upsellStyle + '"' : '') + '>' + upsell + '</div>'
      + '</div>';
  }

  var SPEICHER = {};

  SPEICHER.anker = {};
  SPEICHER.anker[2] = {
    '2.7 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~430 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~2,9 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '5.4 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~504 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~3,7 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '8.1 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~532 € Ersparnis/J.', '✓ Puffer für bewölkte Tage', '✓ ~4,7 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet noch mehr Puffer.'),
    '10.8 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve bei 2 Modulen',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~541 € Ersparnis/J.', '✓ Ideal für Haushalte mit variablem Verbrauch', '✓ ~5,7 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '13.4 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,8 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '16.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,9 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.anker[4] = {
    '2.7 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~823 € Ersparnis/J.', '✓ Ausbaubar bis 16,1 kWh', '✓ ~1,8 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '5.4 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~962 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~2,2 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit mit Stufe 3.'),
    '8.1 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~1100 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,5 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage und dynamische Tarife.'),
    '10.8 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1193 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~2,8 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '13.4 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,8 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '16.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,9 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  SPEICHER.conow = {};
  SPEICHER.conow[2] = {
    '2.00 kWh': speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~421 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,2 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '4.1 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~3,8 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '6.2 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~4,6 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage und dynamische Tarife.'),
    '8.2 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~532 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~5,5 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.2 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,3 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.3 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,3 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.conow[4] = {
    '2.00 kWh': speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~380 € Ersparnis/J.', '✓ Ausbaubar bis 12,3 kWh', '✓ ~3,2 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '4.1 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~3,8 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '6.2 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~4,6 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.2 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~532 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~5,5 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.2 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~6,3 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.3 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~7,3 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  SPEICHER.marstek = {};
  SPEICHER.marstek[2] = {
    '2.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~421 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~2,0 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '4.2 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~495 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~2,8 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '6.4 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~522 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~3,7 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.5 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~532 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~4,6 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität.'),
    '10.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~5,5 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '12.7 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~6,5 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.marstek[4] = {
    '2.1 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~805 € Ersparnis/J.', '✓ Ausbaubar bis 12,7 kWh', '✓ ~1,4 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '4.2 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~934 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~1,7 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '6.4 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~1054 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,0 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '8.5 kWh':  speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1147 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~2,3 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '10.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~5,5 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '12.7 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~6,5 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  SPEICHER.marstekAC = {};
  SPEICHER.marstekAC[2] = {
    '5.1 kWh':   speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~458 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,1 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '10.2 kWh': speicherBox('Volle Kapazität', 98, 'Maximale Nutzung deiner Solaranlage',
      ['✓ Optimale Eigenverbrauchsquote', '✓ ~532 € Ersparnis/J.', '✓ Ideal für größere Haushalte', '✓ ~4,8 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig.')
  };
  SPEICHER.marstekAC[4] = {
    '5.1 kWh':   speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~869 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~1,9 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '10.2 kWh': speicherBox('Volle Kapazität', 98, 'Maximale Nutzung deiner Solaranlage',
      ['✓ Optimale Eigenverbrauchsquote', '✓ ~1100 € Ersparnis/J.', '✓ Ideal für größere Haushalte', '✓ ~2,5 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig.')
  };

  SPEICHER.jackery = {};
  SPEICHER.jackery[2] = {
    '2.5 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Ideal für Single- & 2-Personen-Haushalte',
      ['✓ Deckt deine Grundlast (Kühlschrank, Standby)', '✓ ~430 € Ersparnis/J.', '✓ Ideal für 1-2-Personen-Haushalte', '✓ ~3,4 J. Amortisation'],
      '⚠️ Du verschenkst aktuell noch ca. <strong>XXX €</strong> pro Jahr an das Netz. Mit der nächsten Stufe behältst du dieses Geld für dich.'),
    '5.0 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Maximale Nutzung bei 2 Modulen',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~504 € Ersparnis/J.', '✓ Empfehlung für 2-Modul-Anlagen', '✓ ~4,3 J. Amortisation'],
      'Schließe die Lücke: Hol dir die volle Unabhängigkeit mit der nächsten Stufe.'),
    '7.6 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote',
      ['✓ 0 € Verschenkt – Nutze 100% deiner Ernte selbst', '✓ ~532 € Ersparnis/J.', '✓ Ideal bei 2 Modulen', '✓ ~5,4 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '10.1 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Maximale Reserve & dynamische Tarife',
      ['✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~541 € Ersparnis/J.', '✓ Ideal für variablen Verbrauch', '✓ ~6,6 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität.'),
    '12.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~7,7 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit.'),
    '15.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~9,0 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };
  SPEICHER.jackery[4] = {
    '2.5 kWh':  speicherBox('Grundlast-Optimierung', 65, 'Einstieg – du verschenkst noch viel',
      ['✓ Deckt erste Grundlast', '✓ ~823 € Ersparnis/J.', '✓ Ausbaubar bis 15,1 kWh', '✓ ~2,1 J. Amortisation'],
      '⚠️ Bei 4 Modulen erzeugst du viel mehr Strom – ein kleiner Speicher verschenkt den Großteil davon ans Netz.'),
    '5.0 kWh':  speicherBox('Preis-Leistungs-Sieger', 92, 'Empfehlung für Standard-Haushalte (4 Module)',
      ['✓ Fast am Ziel: Kaum noch Netz-Geschenke', '✓ ~962 € Ersparnis/J.', '✓ Die Empfehlung für 4-Modul-Anlagen', '✓ ~2,5 J. Amortisation'],
      'Schließe die Lücke: Du verschenkst immer noch wertvolle kWh. Hol dir die volle Unabhängigkeit.'),
    '7.6 kWh':  speicherBox('Der Autarkie-Meilenstein', 100, 'Für 100% Eigenverbrauchsquote bei 4 Modulen',
      ['✓ Fast 0 € Verschenkt', '✓ ~1100 € Ersparnis/J.', '✓ Ideal bei 4 Modulen', '✓ ~2,8 J. Amortisation'],
      'Dein System ist jetzt zukunftsfähig. Das nächste Level bietet Puffer für bewölkte Tage.'),
    '10.1 kWh': speicherBox('Smart-Grid Kraftpaket', 100, 'Für 4+ Module & hohen Verbrauch',
      ['✓ Ideal bei 4+ Modulen & hohem Stromverbrauch', '✓ ~1211 € Ersparnis/J.', '✓ Optimiert für dynamische Tarife (Tibber/Awattar)', '✓ ~3,1 J. Amortisation'],
      'Maximiere deine Autarkie und rüste dein Heim für E-Mobilität und elektrisches Heizen.'),
    '12.6 kWh': speicherBox('Maximale Unabhängigkeit', 100, 'Für moderne Haushalte mit E-Auto & Wärmepumpe',
      ['✓ Maximale Versorgungssicherheit & Autarkie', '✓', '✓ Dein vollwertiges Heimspeichersystem', '✓ ~7,7 J. Amortisation'],
      'Gehe den letzten Schritt zur maximalen Versorgungssicherheit für dein gesamtes Haus.'),
    '15.1 kWh': speicherBox('Full-Power Heimspeicher', 100, 'Für E-Auto & Wärmepumpe',
      ['✓ Vollwertiger Ersatz für teure Heimspeichersysteme', '✓', '✓ Maximale Kapazität für E-Auto & Wärmepumpe', '✓ ~9,0 J. Amortisation'],
      '✅ Du genießt die höchstmögliche Netz-Unabhängigkeit und Zukunftsfähigkeit.', 'color:#6b7280;')
  };

  var COLOR_MAPS = {
    anker:     { '2.7 kWh':'yellow',  '5.4 kWh':'green',  '8.1 kWh':'blue',  '10.8 kWh':'purple', '13.4 kWh':'purple', '16.1 kWh':'purple' },
    conow:     { '2.00 kWh':'yellow', '4.1 kWh':'green',  '6.2 kWh':'blue',  '8.2 kWh':'purple',  '10.2 kWh':'purple', '12.3 kWh':'purple' },
    marstek:   { '2.1 kWh':'yellow',  '4.2 kWh':'green',  '6.4 kWh':'blue',  '8.5 kWh':'purple',  '10.6 kWh':'purple', '12.7 kWh':'purple' },
    marstekAC: { '5.1 kWh':'yellow',  '10.21 kWh':'green' },
    jackery:   { '2.5 kWh':'yellow',  '5.0 kWh':'green',  '7.6 kWh':'blue',  '10.1 kWh':'purple', '12.6 kWh':'purple', '15.1 kWh':'purple' }
  };

  function getSpeicherConfig() {
    var title = (
      (window.enetoProductData && window.enetoProductData.title) || document.title
    ).toLowerCase();
    var is4Module = /1[\.\s]?820|1820|2[\.\s]?000\s*w|2000\s*w/.test(title);
    var modules   = is4Module ? 4 : 2;
    if (title.includes('anker'))                                  return { data: SPEICHER.anker[modules],     colors: COLOR_MAPS.anker };
    if (title.includes('conow') || title.includes('cbe'))         return { data: SPEICHER.conow[modules],     colors: COLOR_MAPS.conow };
    if (title.includes('venus e') || title.includes('ac speicher')) return { data: SPEICHER.marstekAC[0],    colors: COLOR_MAPS.marstekAC };
    if (title.includes('marstek') || title.includes('venus'))     return { data: SPEICHER.marstek[modules],   colors: COLOR_MAPS.marstek };
    if (title.includes('jackery'))                                return { data: SPEICHER.jackery[modules],   colors: COLOR_MAPS.jackery };
    return { data: SPEICHER.anker[modules], colors: COLOR_MAPS.anker };
  }

  function updateBox(boxId, data, color, selectedValue) {
    var box = document.getElementById(boxId);
    if (!box) return;
    box.classList.remove(
      'eneto-halterung-infobox--green', 'eneto-halterung-infobox--gray',
      'eneto-halterung-infobox--red',   'eneto-halterung-infobox--yellow',
      'eneto-halterung-infobox--blue',  'eneto-halterung-infobox--purple'
    );
    box.classList.add('eneto-halterung-infobox--' + color);
    var text = data[selectedValue];
    if (text) {
      box.innerHTML = text;
      box.classList.add('is-visible');
    } else {
      box.innerHTML = '';
      box.classList.remove('is-visible');
    }
    var footnote = document.getElementById('eneto-speicher-footnote');
    if (footnote) footnote.hidden = !text;
  }

  function attachListeners() {
    var cfg = getSpeicherConfig();
    var speicherData     = cfg.data;
    var speicherColorMap = cfg.colors;

    var halterungGroup = document.querySelector('.eneto-variants__group[data-option-index="0"]');
    if (halterungGroup) {
      halterungGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('.eneto-variant-btn');
        if (!btn) return;
        var value = btn.getAttribute('data-option-value') ||
          (btn.querySelector('.eneto-variant-label') && btn.querySelector('.eneto-variant-label').textContent.trim());
        if (value) updateBox('eneto-halterung-infobox', halterungData, halterungColor, value);
      });
      var activeBtn = halterungGroup.querySelector('.eneto-variant-btn[aria-pressed="true"]');
      if (activeBtn) {
        var initVal = activeBtn.getAttribute('data-option-value') ||
          (activeBtn.querySelector('.eneto-variant-label') && activeBtn.querySelector('.eneto-variant-label').textContent.trim());
        if (initVal) updateBox('eneto-halterung-infobox', halterungData, halterungColor, initVal);
      }
    }

    var speicherGroup = document.querySelector('.eneto-variants__group[data-option-index="1"]');
    if (speicherGroup) {
      speicherGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('.eneto-variant-btn');
        if (!btn) return;
        var value = btn.getAttribute('data-option-value') ||
          (btn.querySelector('.eneto-variant-label') && btn.querySelector('.eneto-variant-label').textContent.trim());
        if (value) updateBox('eneto-speicher-infobox', speicherData, speicherColorMap[value] || 'green', value);
      });
      var activeBtn2 = speicherGroup.querySelector('.eneto-variant-btn[aria-pressed="true"]');
      if (activeBtn2) {
        var initVal2 = activeBtn2.getAttribute('data-option-value') ||
          (activeBtn2.querySelector('.eneto-variant-label') && activeBtn2.querySelector('.eneto-variant-label').textContent.trim());
        if (initVal2) updateBox('eneto-speicher-infobox', speicherData, speicherColorMap[initVal2] || 'green', initVal2);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();
